export function TripOverview({ circuit, view }) {
  return (
    <div style={{ display: "grid", gridTemplateColumns: "1.7fr 1.3fr", gap: 16 }}>
      <div className="card">
        <div style={{ height: "100%", minHeight: 220, display: "flex" }}>
          <img
            src={view.heroImage}
            alt={circuit.nom}
            style={{ width: "100%", height: "100%", minHeight: 220, objectFit: "cover", borderRadius: "var(--radius)" }}
          />
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <h3 className="card-title" style={{ marginBottom: 14 }}>{circuit.nom}</h3>

          <div style={{ marginBottom: 16 }}>
            <div className="k" style={{ marginBottom: 4 }}>En résumé</div>
            <p style={{ margin: 0, fontSize: 13.5 }}>{view.summary}</p>
          </div>

          <div>
            <div className="k" style={{ marginBottom: 4 }}>Détails du séjour</div>
            <p style={{ margin: 0, fontSize: 13.5, color: "var(--text-2)" }}>{view.details}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TripOverview;
